import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware, compose, combineReducers } from 'redux';
import { IEpiProps, DefaultEpiProps } from './models/epi-props';
import { fetchMiddleware } from '../global/middleware/fetch-middleware';
import { LiturgicalCalendarApp } from './components/liturgical-calendar-app';
import { EpiApiState, epiApiReducerWithDefault } from '../global/ducks/epi-api';
import { SearchApiState, searchApiReducer } from '../global/ducks/search-api';
import { Query } from '../global/functions/query';
import { LiturgicalCalendarState, litugricalCalendarApiReducer } from '../global/ducks/liturgical-calendar-api';


export interface IAppState {
    epiState: EpiApiState<IEpiProps>;
    liturgicalCalendar: LiturgicalCalendarState;

}

export const rootReducer = combineReducers<IAppState>({
    epiState: epiApiReducerWithDefault({ props: DefaultEpiProps }),
    liturgicalCalendar: litugricalCalendarApiReducer,
})

const mount = document.getElementById('liturgical-calendar-app');
const contentId = (window as any).bootstrap.contentId;

// Attach Redux extension and add any middleware (just fetch here)
const composeEnhancers = (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(rootReducer, composeEnhancers(
    applyMiddleware(
        fetchMiddleware,
    )
));

// Set up utility functions
const setQueryParams = (params: { [key: string]: string[] }) => {
    let query = '?';
    Object.keys(params).forEach(key => {
        params[key].forEach(param => {
            query += `${key}=${param}&`
        })
    })
    window.history.replaceState(undefined, undefined, query.substr(0, query.length - 1));
}

const params = Query.getParams();
const setParams = Query.setParams;

if (mount) {

    ReactDOM.render(
        <Provider store={store}>
            <LiturgicalCalendarApp
                contentId={contentId}
                initialParams={params}
                setQueryParams={setParams} />
        </Provider>, mount);
}
